import React, {useLayoutEffect} from "react";
import * as SCREENS from "../constants/screens";

import guerraLogo from "../assets/images/logo-blue.png";

export default function Welcome({ dataManager }) {
  const { data, setData, sendDataToSheet } = dataManager;

  function nextScreen(associate) {
    // const screen = associate ? SCREENS.ADMINISTRATORS : SCREENS.NAME;
    const screen = associate && SCREENS.ADMINISTRATORS;
    const name = associate ? "" : data.name;

    // sendDataToSheet(name, data.phone, associate, false, data.administrator, "Iniciou simulação")

    setData({
      ...data,
      name: name,
      associateMode: associate,
      screen: screen,
    });
  }

  return (
    <section className="welcome-screen container">
      <img
        src={guerraLogo}
        className="welcome-guerra-logo"
        alt="Logomarca da Guerra Consórcios"
      />
      <div>
        <h1 className="mb-3">Olá! Vamos fazer uma simulação?</h1>
        <h2>
          Para começar a simulação, aperte o botão iniciar.
        </h2>
      </div>
      <div className="row w-100">
        <button
          className="btn btn-primary btn-lg col-12 mb-2"
          onClick={() => nextScreen(true)}
        >
          Iniciar
        </button>
      </div>
      {/* <PDFDownloadLink document={<MyDocument />} fileName="proposta.pdf">
        {({ blob, url, loading, error }) =>
          loading ? 'Loading document...' : 'Download now!'
        }
      </PDFDownloadLink>
      <PDFViewer width={800} height={1000}>
        <MyDocument />
      </PDFViewer> */}
    </section>
  );
}
